module.exports = "/images/chart.svg?91cf1ec64fd5ed1970c08320906299ce";